import type { OrderConfirmationAppliedDiscountAnalytics } from '@library/api-customer-engagement-experience'
import { queueTrackingEvent } from '@library/tracking-integration'

type AppliedDiscountTrackingEvent = {
  action: string
  properties?: Record<string, unknown>
}

// The xAPI names the event `event`; the tracking integration calls it `action`. Properties are
// forwarded untouched, whatever kind of discount they describe.
export const trackAppliedDiscountShown = (
  analytics?: OrderConfirmationAppliedDiscountAnalytics,
) => {
  if (!analytics) return

  queueTrackingEvent<AppliedDiscountTrackingEvent>({
    action: analytics.event,
    properties: analytics.properties,
  })
}
